module.exports = __webpack_public_path__ + "static/img/banner2.f8e5619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner2.jpg
// module id = CKPc
// module chunks = 1